import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { SharedModalInfoComponent } from '../../../../../shared/modal-info/modal-info.component';
import { FormGroup } from '@angular/forms';
import { User } from '../../../../../autentication/models/user';
import { Auth } from '../../../../../autentication/Auth';
import { PixKeyType } from '../../../models/key-type.enum';
import { PixKeysService } from '../../keys.service';
import { AutenticationService } from '../../../../../autentication/autentication.service';
import { Util } from '../../../../../utils/util';
import { PixKeysErrorCode } from '../../../models/keys-error-code.enum';
import { PixKey } from '../../../models/key.model';
import { PixKeysClaimService } from '../../keys-claim.service';

@Component({
	selector: 'app-pix-keys-create-assignature',
	templateUrl: './assignature.component.html',
	styleUrls: ['./assignature.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixKeysCreateAssignatureComponent implements OnInit {

	public submited = false;
	public form: FormGroup;
	public user: User;
	public selectedKey: PixKey;
	public topText = '';
	public guid = '';
	public claimType: PixKeysErrorCode;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		public dialog: MatDialog,
		private pixKeysCreateService: PixKeysService,
		private autenticationService: AutenticationService,
		private pixKeysClaimService: PixKeysClaimService,
	) {}

	ngOnInit() {
		this.user = Auth.getInstance().getUser();
		this.selectedKey = this.pixKeysCreateService.getPixKey();
		this.guid = Util.generateGUID();
		if (!this.checkParams()) {
			this.goToList();
			return;
		}
		this.createText();
	}

	createText() {
		switch (this.selectedKey.tipoChave) {
			case PixKeyType.CPF:
				this.topText = 'CPF: ' + Util.formatCpfCnpj(this.user.cpfCnpj);
				break;
			case PixKeyType.CNPJ:
				this.topText = 'CNPJ: ' + Util.formatCpfCnpj(this.user.cpfCnpj);
				break;
			case PixKeyType.EMAIL:
				this.topText = 'Email: ' + this.selectedKey.codigo;
				break;
			case PixKeyType.PHONE:
				this.topText = 'Telefone Celular: ' + Util.formatPhone(this.selectedKey.codigo);
				break;
			case PixKeyType.EVP:
				this.topText = 'Chave aleatória';
				break;
		}
	}

	checkParams(): boolean {
		if (!this.selectedKey || (this.selectedKey.tipoChave !== PixKeyType.EVP && !this.selectedKey.codigo) || !this.user) {
			return false;
		} else {
			return true;
		}
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
	}

	submit(message: boolean) {
		this.submited = message;

		if (this.submited && this.form.valid) {
			this.addAuthToken();
			this.sendAssignature();
		}
	}

	addAuthToken() {
		if (this.form.value.token) {
			Auth.passToken = this.form.value.token;
		}
	}

	addAuthSignature() {
		if (this.form.value.eletronicSignature) {
			Auth.assinaturaEletronica = this.form.value.eletronicSignature;
		}
	}

	sendAssignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.addAuthSignature();
				this.sendRequest();
			}
		});
	}

	sendRequest() {
		this.pixKeysCreateService.post(this.selectedKey.codigo, this.selectedKey.tipoChave, this.guid).subscribe(
			data => {
				if (data.Sucesso) {
					this.openModalSuccess();
				}
			},
			err => this.handleError(err)
		);
	}

	postClaim() {
		this.pixKeysClaimService.post(this.selectedKey.codigo, this.selectedKey.tipoChave, this.guid).subscribe(data => {
			if (data.Sucesso) {
				this.openModalClaimSuccess();
			}
		});
	}

	handleError(err) {
		if (err.error && err.error.CodigoErro && err.error.Tipo === 422) {
			this.claimType = err.error.CodigoErro;
			switch (err.error.CodigoErro) {
				// CHAVE_JA_CADASTRADA - Chave cadastrada para a conta logada (Nada a fazer)
				case PixKeysErrorCode.CHAVE_JA_CADASTRADA:
					this.goToList();
					break;
				// CHAVE_VINCULADA_OUTRA_CONTA - Chave cadastrado para outra conta com mesmo CPF e Banco (portabilidade automática)
				case PixKeysErrorCode.CHAVE_VINCULADA_OUTRA_CONTA:
					this.showModalKeyAnotherAccount();
					break;
				// CHAVE_VINCULADA_OUTRO_BANCO - Chave cadastrada para mesmo CPF em outro Banco (portabilidade)
				case PixKeysErrorCode.CHAVE_VINCULADA_OUTRO_BANCO:
					this.showModalKeyAnotherBank();
					break;
				// CHAVE_VINCULADA_OUTRO_USUARIO - Chave vinculada a outro CPF (reivindicação)
				case PixKeysErrorCode.CHAVE_VINCULADA_OUTRO_USUARIO:
					this.showModalKeyAnotherUser();
					break;
			}
		}
	}

	showModalKeyAnotherBank() {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '360px',
			data: {
				title: 'Essa chave já vinculada a uma outra conta',
				topText: 'Deseja iniciar processo de portabilidade?',
				text: 'Para concluir esse processo acesse a conta onde essa chave está registada e confirme o pedido de portabilidade em até 7 (sete) dias.',
				btnName: 'Iniciar portabilidade',
				btnBackName: 'Cancelar'
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.postClaim();
			} else {
				this.goBack();
			}
		});
	}

	showModalKeyAnotherAccount() {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '390px',
			data: {
				title: 'Chave vinculada a outra conta Omni Banco',
				topText: 'Deseja iniciar o processo de\nportabilidade?',
				text: 'Como essa chave encontra-se em uma outra conta Omni Banco, o processo é automático e não requer confirmação',
				btnName: 'Realizar portabilidade',
				btnBackName: 'Cancelar'
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.postClaim();
			} else {
				this.goBack();
			}
		});
	}

	showModalKeyAnotherUser() {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '360px',
			data: {
				title: 'Essa chave já foi registrada por outra pessoa',
				topText: 'Você precisa solicitar o uso dessa chave como chave Pix na Omni',
				text: 'O prazo máximo para conclusão desse processo é de 14 (quatorze) dias. Deseja solicitar a reivindicação de posse?',
				btnName: 'Reivindicar posse',
				btnBackName: 'Cancelar'
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.postClaim();
			} else {
				this.goBack();
			}
		});
	}

	openModalClaimSuccess() {
		let title = '';
		let text: string;

		switch (this.claimType) {
			case PixKeysErrorCode.CHAVE_VINCULADA_OUTRA_CONTA:
				title = 'Processo de portabilidade\nconcluído com sucesso.';
				text = 'Como essa chave encontra-se em uma outra conta Omni Banco, o processo é automático e não requer confirmação';
				break;
			case PixKeysErrorCode.CHAVE_VINCULADA_OUTRO_BANCO:
				title = 'Processo de \nportabilidade iniciado';
				text = 'Para concluir esse processo acesse a conta onde essa chave está registada e confirme o pedido de portabilidade\nem até 7 (sete) dias.';
				break;
			case PixKeysErrorCode.CHAVE_VINCULADA_OUTRO_USUARIO:
				title = 'Processo de reivindicação \nde chave iniciado';
				text = 'Sua solicitação foi enviada. Agora, \nvocê deve esperar até 14 dias para a reivindicação ser confirmada.';
				break;
		}

		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '360px',
			data: {
				title: title,
				topText: this.topText,
				text: text,
				btnName: 'Fechar'
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			this.goToList();
		});
	}

	openModalSuccess() {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '360px',
			data: {
				title: 'Chave cadastrada com sucesso! ',
				topText: this.topText,
				text: 'Agora, usuários do Pix podem fazer pagamentos para você informando essa chave, sem a necessidade de digitar seus dados. ',
				btnName: 'Fechar'
			}
		});

		dialogRef.afterClosed().subscribe(() => { this.goToList(); });
	}

	goToList = () => this.router.navigate(['pix/chaves/listar']);
	goBack = () => this.router.navigate(['pix/chaves/criar']);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/keys/create/assignature/assignature.component.ts